import { CommonHttpOption } from "./../../base/common-http-option";
import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { Observable } from "rxjs";
import { ServiceRoute } from "../../base/service-route";
import { IPaymentation } from "src/app/interfaces/paymentation";

@Injectable({
  providedIn: "root"
})
export class PaymentService {
  constructor(private core: CoreService) { }

  pay(data: any, bank: string): Observable<any> {
    var route = '';
    switch (bank) {
      case 'melli':
        route = ServiceRoute.pay.getTocken
        break;
      case 'saman':
        route = ServiceRoute.pay.getSamanTocken
        break;
      default:
        route = ServiceRoute.pay.getSamanTocken
    }
    return this.core.post(
      route,
      data,
      new CommonHttpOption().headers
    );
  }
  paymentation(data: IPaymentation): Observable<any> {
    return this.core.post(
      ServiceRoute.pay.paymentation,
      data,
      new CommonHttpOption().headers
    );
  }
  getWallet(nationalCode: number): Observable<any> {
    return this.core.get(
      ServiceRoute.pay.GetWallet + nationalCode,
      new CommonHttpOption().headers
    );
  }
  GetActiveBank(invoiceId: number): Observable<any> {
    return this.core.get(
      ServiceRoute.pay.GetActiveBank + invoiceId,
      new CommonHttpOption().headers
    );
  }
  paymentCashemaining(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.pay.paymentCashemaining,
      data,
      new CommonHttpOption().headers
    );
  }

  // Student Services
  getWalletSTU(params: any): Observable<any> {

    return this.core.get(
      ServiceRoute.pay.GetWalletSTU + params.CompanyEncryptId,
      new CommonHttpOption().headers
    );
  }
  paymentCashemaininSTU(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.pay.paymentCashemainingSTU,
      data,
      new CommonHttpOption().headers
    );
  }
}
